module.exports = " <li :class=\"{ 'active': isCurrent }\"> <a href=\"\" @click.prevent=select> {{ number }} </a> </li> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/pagination/Page.vue
// module id = 544
// module chunks = 0